import React, { useEffect, useState } from "react"
import Illust1 from "../asset/Illust1"
import Card3 from "../components/Card3"
import Card4 from "../components/Card4"
import ComparisonGraph from "../components/ComparisonGraph"
import CardFrame1 from "../components/CardFrame1"
import styled from "styled-components"
import { Map } from "../components/Map"
import CardFrame2 from "../components/CardFrame2"
import IlustMG from "../asset/IlustMG"

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 44px;
  flex: 1 0 0;
  align-self: stretch;
`

const Grid1 = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  gap: 24px;
  align-self: stretch;
`

const Grid2 = styled.div`
  display: flex;
  align-items: center;
  gap: 128px;
`

const DashBoard = () => {
  const [location, setLocation] = useState<string>("전체")

  return (
    <Wrapper>
      <Grid1>
        {/* <IlustMG /> */}
        <Illust1 />
        <CardFrame1 />
        <Card3 />
        <Card4 />
      </Grid1>
      <Grid2>
        <ComparisonGraph />
        <Map setLocation={setLocation} />
        <CardFrame2 location={location} setLocation={setLocation} />
      </Grid2>
    </Wrapper>
  )
}

export default DashBoard
